(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-wholesale"]) return;
  try {
    

  var container = document.getElementById('main-collection-wholesale');
  if (container) {
    container.addEventListener('mouseover', function (e) {
      var swatch = e.target.closest('[data-preview-src]');
      if (!swatch) return;
      var card = swatch.closest('.wcg-card');
      if (!card) return;
      var img = card.querySelector('.wcg-card__img');
      if (!img) return;
      img.src = swatch.dataset.previewSrc;
    });

    container.addEventListener('mouseout', function (e) {
      var swatch = e.target.closest('[data-preview-src]');
      if (!swatch) return;
      if (swatch.contains(e.relatedTarget)) return;
      var card = swatch.closest('.wcg-card');
      if (!card) return;
      var img = card.querySelector('.wcg-card__img');
      if (!img || !img.dataset.originalSrc) return;
      img.src = img.dataset.originalSrc;
    });

    // Capture-phase listener: intercept swatch clicks BEFORE the .wcg-card <a> can navigate.
    // This must use capture=true so it fires before the parent <a> processes the click.
    container.addEventListener('click', function (e) {
      var swatch = e.target.closest('.product-card-img-swatch[data-swatch-href]');
      if (!swatch) return;
      e.preventDefault();
      e.stopPropagation();
      var href = swatch.dataset.swatchHref;
      if (href) window.location.href = href;
    }, true);
  }
  

  document.querySelectorAll('.product-card-img-swatch').forEach((swatch) => {
  swatch.addEventListener('click', function () {
    const variant = this.dataset.variant;

    // Buscar la card padre
    const card = this.closest('.wcg-card');

    if (!card) return;

    // Obtener la URL del producto
    const productUrl = card.getAttribute('href') || card.querySelector('a')?.href;

    if (!productUrl) return;

    // Crear nueva URL con variant
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('variant', variant);

    console.log(url.toString());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
